import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n/i18n"; // Inicializa i18next ANTES del render
import App from "@/App";
import { silentResubscribe } from "@/services/pushService";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA support
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then(() => {
        // Once the SW is ready, silently refresh this device's push subscription
        // so all active devices stay registered even if another device toggled
        // notifications off (which used to deactivate all devices at once).
        silentResubscribe();
      })
      .catch((err) => {
        console.warn("[SW] Registration failed:", err);
      });
  });

  // When the active SW sends SW_UPDATED (new version activated),
  // dispatch a DOM event so the React app can show a "reload" toast.
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data?.type === "SW_UPDATED") {
      window.dispatchEvent(
        new CustomEvent("startip:sw-updated", {
          detail: { version: event.data.version },
        })
      );
    }
  });
}
